<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<searchForm ref="MyTerm" @show="show" @handleSubmit="handleSubmit"></searchForm>
		<Table :columns="columns1" :data="data" :height="tableHeight" size="small">
			<MyPage slot="footer" ref="sonPage" :param="SelectParam" :url="getUsersUrl" @listData='getDeviceData'></MyPage>
		</Table>
		<infoModal @handleSubmit="handleSubmit" ref="ItemModal"></infoModal>
		<!-- <DistributeModal  ref="distributeModal"></DistributeModal> -->
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi';
	import searchForm from './Template/UserForm.vue';
	import infoModal from './Template/UserModal.vue';
	// import DistributeModal from './Template/DistributeModal.vue';
	export default {
		components: {
			searchForm,
			infoModal,
			// DistributeModal
		},
		data() {
			return {
				getUsersUrl: webapi.base_api_url + '/System/GetUsers',
				//查询组件的参数
				SelectParam: {},
				loadingStatus: false,
				tableHeight: "650",
				BreadcrumbList: [this.$tt('系统管理'), '>>', this.$tt('用户管理')],
				childOperatorList: [],
				//table标题数据
				columns1: [
					// {
					// 	title: 'ID',
					// 	key: 'Id',
					// 	width: 100
					// }, 
					{
						title: this.$tt('用户账号'),
						key: 'Name',
					},
					{
						title: this.$tt('用户名称'),
						key: 'DisplayName',
					},
					// {
					// 	title: '登录密码',
					// 	key: 'Password',
					// 	width: 120
					// },
					// {
					// 	title: '邮箱',
					// 	key: 'Email',
					// 	width: 200
					// },
					// {
					// 	title: '手机号码',
					// 	key: 'Phone',
					// 	width: 120
					// },
					{
						title: this.$tt('角色'),
						key: 'RoleId',
						render: (h, params) => {
							return h('div', params.row.RoleName)
						}
					},
					{
						title: this.$tt('状态'),
						key: 'Status',
						render: (h, params) => {
							return h('div', params.row.StatusDesc)
						}
					},
					{
						title: this.$tt('所属运营商'),
						key: 'OperatorName',
					},
					// {
					// 	title: '场站列表',
					// 	key: 'StationArray',
					// 	width: 120,
					// 	render: (h, params) => {
					// 		let arr = []
					// 		params.row.StationArray.map(item => {
					// 			this.StationList.map(item2 => {
					// 				if (item2.StationId == item) {
					// 					arr.push(item2)
					// 				}
					// 			})
					// 		})
					// 		return h('Poptip', {
					// 			props: {
					// 				trigger: 'hover',
					// 				title: '所属场站',
					// 				placement: 'bottom'
					// 			}
					// 		}, [
					// 			h('Tag', this.$tt('查看')),
					// 			h('div', {
					// 				slot: 'content'
					// 			}, [
					// 				h('ul', arr.map(item => {
					// 					return h('li', {
					// 						style: {
					// 							textAlign: 'center',
					// 							padding: '4px'
					// 						}
					// 					}, item.StationName)
					// 				}))
					// 			])
					// 		]);
					// 	}
					// },
					// {
					// 	title: '创建者',
					// 	key: 'Creator',
					// 	width: 300
					// },
					{
						title: this.$tt('建档时间'),
						key: 'CreateTime',
					},
					//{
					// 	title: '修改者',
					// 	key: 'Modifier',
					// 	width: 300
					// },{
					// 	title: '修改时间',
					// 	key: 'ModifyTime',
					// 	width: 300
					// }, 
					{
						title: this.$tt('操作'),
						key: 'action',
						align: 'center',
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('edit') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show('up', params.row)
										}
									}
								}, this.$tt('修改')) : h(),
								// h('Button', {
								// 	props: {
								// 		type: 'primary',
								// 		size: 'small'
								// 	},
								// 	style: {
								// 		marginRight: '5px'
								// 	},
								// 	on: {
								// 		click: () => {
								// 			this.show('distribute', params.row.Id)
								// 		}
								// 	}
								// }, this.$tt('分配站点')),
								this.methodList.filter(item => this.hasWidgets(item.name)).length > 0 ? h('Dropdown', {
										on: {
											//为了不误操作，确定取消相反
											'on-click': (name) => {
												this.$Modal.confirm({
													title: name,
													okText: this.$tt('取消'),
													cancelText: this.$tt('确定'),
													onCancel: () => {
														this.otherMethodStation(name,
															params.row.Id);
													}
												});
												// this.show("deleteStation", params.row.Id)
											}
										}
									},
									[
										h('Button', {
											props: {
												type: 'primary',
												size: 'small',
											},
											style: {
												marginRight: '5px'
											},
										}, this.$tt('其他操作')),
										h('DropdownMenu', {
											slot: 'list'
										}, [
											this.methodList.filter(item => this.hasWidgets(item.name)).map((
											item) => { // this.productTypeList下拉框里的data
												return h('DropdownItem', {
														props: {
															name: item.Status
														}
													},
													item.Status
												)
											})
										])
									],
								) : h(),
							]);
						}
					}
				],
				data: [],
				methodList: [{
					Id: 0,
					name: 'unlock',
					Status: this.$tt('正常')
				}, {
					Id: 9,
					name: 'lock',
					Status: this.$tt('锁定')
				}, ]
			}
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 160;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.SelectParam = this.$refs.MyTerm.formInline
			this.$nextTick(() => {
				this.handleSubmit();
			})
		},
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations',
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//删除修改之外的其他操作
			otherMethodStation: function(name, Id) {
				let typeNum = (this.methodList.filter(function(item, index, arr) {
					return item.Status == name
				})[0]).Id
				this.$axios.post(webapi.base_api_url + "/System/SetUserStatus", {
					Id: Id,
					Status: typeNum
				}).then(res => {
					if (res.data.Code == 0) {
						this.$Message.info(name + this.$tt('成功'));
						this.handleSubmit();
					}
				})
			},
			/******************组件固定方法*************************/
			show: function(type, params) {
				switch (type) {
					case 'up':
						this.$refs.ItemModal.show(type, params)
						break;
					case 'add':
						this.$refs.ItemModal.show(type, params)
						break;
						// case 'distribute':
						// this.$refs.DistributeModal.show(type, params)
						// break;
				}
			},
			getDeviceData: function(data) {
				console.log(data)
				this.data = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 160;
			},
			getChildOperatorList: function () {
				this.$axios.post(webapi.base_api_url + '/System/GetChildOperatorList').then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						this.childOperatorList = res.data.Data.List
					}
				})
			}
		},
	}
</script>

<style>
</style>
